export default __webpack_public_path__ + "static/media/polygon.a8d6a750.svg";